import * as TextAnim from "../../src/js/lib/text_anim";

const { Component, DOMUtils, Utils } = window.Liftoff;

// Duration (in ms) of gap between restarts of the typing effect.
const REPEAT_TYPING_EFFECT_EVERY = 3000;
// Duration (in ms) of gap between appearance of each letter during the typing effect.
const TYPING_INTERVAL = 50;

const TEXT_ALIGN_TO_FLEX = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
};

Component.register(
  "text",
  class Text extends Component {
    constructor(config) {
      super(config);

      Utils.assignWithDefaults(
        this,
        {
          text: null,
          maxLines: null,
          interval: 3000,
          duration: 400,
          typingEffect: false,
          repeatTypingEffect: false,
          startTypingAfter: 0,
          style: {},
        },
        this.config
      );
      this.maxLines = this.maxLines === Infinity ? 0 : this.maxLines;

      this.animation =
        config.animation == null || config.animation === "none"
          ? null
          : config.animation;
      this.switchers = (config.switchers || []).filter((switcher) => {
        return (
          switcher.replacements != null && switcher.replacements.length > 0
        );
      });
      this.started = false;
      this.on("set", ({ val }) => {
        this.text = val;
        this.layout(this.parentNode);
      });
    }

    layout(parentNode) {
      super.layout(parentNode);
      DOMUtils.empty(this.parentNode);
      this.el = document.createElement("div");
      this.el.classList.add("text");
      this.el.innerHTML = this.text;
      Object.assign(this.el.style, this.style);
      this.parentNode.appendChild(this.el);
      this.initSwitchers();
      this.resize();
    }

    initSwitchers() {
      this.switchers.forEach((switcher, i) => {
        const regex = new RegExp(switcher.targetText, "g");
        this.el.innerHTML = this.el.innerHTML.replace(
          regex,
          `<div class="text-switcher text-switcher-${i}"></div>`
        );
        const switcherEls = this.el.querySelectorAll(`.text-switcher-${i}`);
        Array.from(switcherEls).forEach((switcherEl) => {
          let width = -Infinity;
          switcher.replacements.forEach((replacement) => {
            const replacementEl = document.createElement("div");
            replacementEl.style.whiteSpace = "nowrap";
            replacementEl.innerHTML = replacement.replacementText;
            replacementEl.style.webkitAnimationDelay = `${switcher.interval}ms`;
            replacementEl.style.webkitAnimationDuration = `${switcher.duration}ms`;
            switcherEl.appendChild(replacementEl);
            width = Math.max(
              width,
              replacementEl.getBoundingClientRect().width
            );
          });
          switcherEl.style.height = getComputedStyle(switcherEl).lineHeight;
          switcherEl.style.width = `${width}px`;
          // NOTE(oscar): "left" is used on older creatives missing `textAlign`.
          switcherEl.style.justifyContent =
            TEXT_ALIGN_TO_FLEX[switcher.textAlign || "left"];
          switcherEl.dataset.switcherIndex = i;
        });
      });
    }

    startSwitchers() {
      const animateIn = (el) => {
        const animationEndPromise = DOMUtils.animationEndPromise(el);
        el.classList.add("fade-in-enter-up");
        return animationEndPromise;
      };
      const animateOut = (el) => {
        const animationEndPromise = DOMUtils.animationEndPromise(el);
        el.classList.add("fade-out-exit-up");
        return animationEndPromise;
      };
      const switcherEls = this.el.querySelectorAll(".text-switcher");
      Array.from(switcherEls).forEach((switcherEl) => {
        let currentReplacementIndex = 0;
        const replacementEls = Array.from(switcherEl.children);
        const animateNext = () => {
          if (!this.started) return;
          const nextIndex =
            (currentReplacementIndex + 1) % replacementEls.length;
          const exitingEl = replacementEls[currentReplacementIndex];
          const enteringEl = replacementEls[nextIndex];
          Promise.all([animateIn(enteringEl), animateOut(exitingEl)]).then(
            () => {
              if (!this.started) return;
              enteringEl.classList.remove("fade-in-enter-up");
              exitingEl.classList.remove("fade-out-exit-up");
              currentReplacementIndex = nextIndex;
              animateNext();
            }
          );
        };
        animateNext();
      });
    }

    startTypingAnimation() {
      if (!this.typingEffect || !this.started) return;

      const textDOM = TextAnim.getTextDom(this.text);
      const textDOMLength = TextAnim.domCountCharacters(textDOM);

      const setTypingIndex = (index) => {
        const textDOMSlice = TextAnim.domSlice(textDOM, index);
        TextAnim.moveChildrenFromNode(this.el, textDOMSlice.tree);
      };

      const animateTypingIndex = (index) => {
        // TODO(cory) If we change text animation so that letters appear in different ways (eg. sliding in),
        // we should animate the next letter by taking it as its own DOM slice, then animate that into the
        // correct location, then remove that slice in the next call to `setTypingIndex`.
        if (index <= textDOMLength) {
          setTypingIndex(index);
          setTimeout(() => animateTypingIndex(index + 1), TYPING_INTERVAL);
        } else if (this.repeatTypingEffect) {
          setTimeout(
            () => this.startTypingAnimation(),
            REPEAT_TYPING_EFFECT_EVERY
          );
        }
      };

      setTypingIndex(0);
      setTimeout(() => animateTypingIndex(1), this.startTypingAfter);
    }

    load() {}

    resize() {
      if (Utils.type(this.maxLines) === "number" && this.maxLines >= 1) {
        const nLines = Math.max(this.text.split("<br").length, this.maxLines);
        this.el.style.fontSize = `${DOMUtils.getFontSizeToFitLines(
          this.el,
          nLines
          )}px`;
      }
    }

    start() {
      if (this.el) {
        this.started = true;
        this.el.classList.toggle("strafe", this.animation === "strafe");
        this.startSwitchers();
        this.startTypingAnimation();
      }
    }

    stop() {
      this.started = false;
      if (this.el) {
        this.el.classList.toggle("strafe", this.animation === "strafe");
      }
    }

    restart() {
      this.start();
    }
  }
);



// WEBPACK FOOTER //
// ./components/text/text.js